@if (currentSubState === TreatmentSelectionSubstate.PRODUCT_SELECTION ){
	<tm2-anamnese-product-selection
		[isUserProfessionalCertified]="isUserProfessionalCertified"
		[isUserOrcadentCertified]="isUserOrcadentCertified"
		[isUserFunctionalSplintCertified]="isUserFunctionalSplintCertified"
		(next)="onNext($event)"
	></tm2-anamnese-product-selection>
}

@if (currentSubState === TreatmentSelectionSubstate.OPTIONS ){
	<tm2-anamnese-options
	[anamnese]="anamnese"
	[isProfessionalSubsequentOrder]="isProfessionalSubsequentOrder"
	(next)="onNext($event)"
	></tm2-anamnese-options>
}

@if(currentSubState ===TreatmentSelectionSubstate.QUESTIONNAIRE){
	@if (isProfessionalProduct){
		<tm2-anamnese-questionaire
		[anamnese]="anamnese"
		[level]="questionnaireScopeLevel"
		(next)="onNext($event)"
		></tm2-anamnese-questionaire>
	}
	@else if (isOrcadentProduct){
		<tm2-anamnese-questionnaire-orcadent
			(next)="onNext($event)"
		></tm2-anamnese-questionnaire-orcadent>
	}
	@else if( anamnese?.product?.key === ProductKey.MICHIGAN_SPLINT){
		<tm2-anamnese-questionnaire-michigan
			[product]="anamnese?.product"
			(next)="onNext($event)"
		></tm2-anamnese-questionnaire-michigan>
	}
}
